//devnet
export const environment = {
  production: false,
  server: "aws", // This will be overwritten by the script during build time
  sol: {
    chainIdInt: 103,
    usdcTokenAddress: 'DZhmFKmhiahcfd2o2RVE7jNGGrZnL7KNUgEh7huWXE1r', //USDC TOKEN ADDRESS
    usdtTokenAddress: 'usdRjXs6N7e2EHKtinvYQhds2Y4uTpSYrYd5iNAw6Vq', //USDT TOKEN ADDRESS
    presaleAddress: 'Ej3MfTR62qW8dPwK1eBQ7Q5Ti23YVnDkYiYMgpWRgbv9',
    SolRpcUrl: 'https://api.devnet.solana.com',
    SolBackupRpcUrl: 'https://api.devnet.solana.com',
    otherAccountUsdc: 'A5PXBRWzy3dT3e4y332MnoHSiio7ujpcm9sUALmyttRd', // USDC TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountUsdt: '55yoz1i8ebLVDCwRRM2XusQjP1ZgKpeebvDTsHwypCsu', // USDT TOKEN ACCOUNT ADDRESS - USER LEVEL
    otherAccountSol: '67TyzJqxjKjmCjH3gdABV2TrAuZckLMwh5uXc4RpPjpm', // WALLET ADDRESS
    chainlinkFeed: '99B2bTijsU6f1GCT73HmdR7HCFFjGMBcPZY6jZ96ynrR', // USED TO FETCH SOL CURRENT PRIZE, THIS VARIOUS ACCORDING TO TOKEN
    chainlinkProgram: '7UVimffxr9ow1uXYxsr4LHAcV58mLzhmwaeKvJ1pjLiE', // USED FOR CHAIN LINK FEED, REMAINS SAME FOR ALL TOKENS
    gasFees: 0.0001,
    blockExplorerURL: 'https://solscan.io/tx/',
  },
  eth: {
    chainId: '0xaa36a7', //hexadecimal for metamask
    chainIdInt: 11155111,
    chainName: 'Ethereum Mainnet',
    gasFees: 0,
    purchaseToken: 'ETH',
    hasStaking: false,
    nativeFunction: 'buyWithEth',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x8a0b93c10611FA63C4b304B6219b4f9CdAcd08F3',
    usdTAddress: '0x9fa2AE3c0a571BbBFd17E74d7470b6c444A87aF2',
    usdcAddress: '0x232331e4e45582742A2D717562Cd682fA132b799',
    rpcURL: 'https://1rpc.io/sepolia',
    backupRPC: 'https://1rpc.io/sepolia',
    blockExplorerURL: 'https://etherscan.io/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0xaa36a7',
          chainName: 'Ethereum Mainnet',
          nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://rpc.ankr.com/eth'],
          blockExplorerUrls: ['https://etherscan.io/'],
        },
      ],
    },
  },

  minToken: 0,
  robots: "noindex, follow",
  tokenName: '$QELT',
  iidDashFx: 0,
  urlDashFx_aws: '',
  urlDashFx_firebase: '',
  urlDashFx_cloudfront: '',
  wertOrigin: 'https://sandbox.wert.io', // testnet
  partnerId: '01HK57C8XMFEVRTMAW55NBD9W2', // testnet
  wertUrl: 'https://ijs2jkwmnzohnnjppqkypl2avq0hhlcm.lambda-url.eu-west-2.on.aws/', // testnet
  referUrl: 'https://fztdp5he4ueq4nytzyj2ycx7vm0wwqth.lambda-url.eu-west-2.on.aws/',
  bwUniversalLink: 'https://best-wallet-dev.web.app',
  bwDeepLink: 'bw-dev://app/connect?',
  bwApiUrl: 'https://d19yvvzbif6vnj.cloudfront.net/webhook-service-api/presale',
  showBestWallet: false,
  domain: 'https://presale.qelt.ai', // replace with live site URL [NO SLASH IN THE END]
  sseUrl: 'https://dtxw9xix4exl0.cloudfront.net/presale-analytics-service/v1/api/sse-by-slug?slug=QELT&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzbHVnIjoiUUVMVCIsImlhdCI6MTc3MDM4MDIxMX0.ifujKmC2xd0oXXWBCK_a0wmAJ9K2AxmgBl20iB9UNx8',
  notificationTimeout: 7000,
  presaleName: 'QXMP Reserve Stable',
  presale_singular_link: 'https://best.sng.link/Dnio2/ii4j9?_smtype=3',
  post_presale_singular_link: '',
  wertOnRampUrl: '', // will change according to the presales.
  twitterId: '@qeltblockchain', // twitter handler id. i.e. '@abc_TWIT',
  reownProductId: '4c9c7ef0bfd4254308c0516f200d0105',
  isVwoEnabled: false,
  isClaimEnabled: false, // need to set it true when claim is live
  wertSigner: 'CYdZAb4i2oaz5CiAvwenMyUVm2DJdd2cWKsekKxxXCQX',
  stripe_url: "https://55o6blkcv5jrxc5mskof7ezxvi0mosik.lambda-url.eu-west-2.on.aws/",
  stripe_domain: "http://d1kbdp9cpzi1w3.cloudfront.net"
};

